// extracted by mini-css-extract-plugin
module.exports = {"typing-indicator":"_2lnkQr","dot":"_12OH4v","blink":"_3C09jq","typing-indicator-message-bubble":"_1_0qxV"};